export const PENDING_RETURN_ACTION_IDS = {
    AUTO_DELIVERY_DETAILS: 'AUTO_DELIVERY_DETAILS',
    AUTO_DELIVERY_DETAILS_EXTENDED: 'AUTO_DELIVERY_DETAILS_EXTENDED',
} as const;

export type PendingReturnActionId = (typeof PENDING_RETURN_ACTION_IDS)[keyof typeof PENDING_RETURN_ACTION_IDS];
